import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { $messageCentreStore, $paymentByIdStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { BaseInput, Button, ErrorMessage, Modal, Text } from '@shared/widgets';

interface IForm {
  reference: string;
}
const DEFAULT_VALUES: IForm = { reference: '' };

interface SwiftConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SwiftConfirmationModal = (props: SwiftConfirmationModalProps) => {
  const { navigate } = useRouteHook();

  const paymentStore = useUnit($paymentByIdStore.store);

  const { control, formState, handleSubmit, reset } = useForm<IForm>({
    defaultValues: { ...DEFAULT_VALUES, reference: paymentStore.data?.referenceNumber || '' },
  });

  const { t } = useTranslation();

  const closeHandler = () => {
    props.onClose();
    reset({ ...DEFAULT_VALUES, reference: paymentStore.data?.referenceNumber || '' });
  };
  const submitHandler = async (data: IForm) => {
    await $messageCentreStore.events.createNewThreadWithMessage({ subject: 'SWIFT Confirmation', body: data.reference, file: undefined });
    paymentStore.data?.referenceNumber && navigate(RoutePaths.messages.onNavigate());
    closeHandler();
  };
  return (
    <Modal isOpen={props.isOpen} onClose={closeHandler} title='SWIFT Confirmation' width='380px'>
      <form className='flex flex-col gap-2' noValidate onSubmit={handleSubmit(submitHandler)}>
        <Text>Please provide transaction reference number to request SWIFT Confirmation</Text>
        <Controller
          name='reference'
          control={control}
          rules={{ required: t('errors.form.required', { ns: 'common' }) }}
          render={({ field, fieldState: { error } }) => (
            <div>
              <BaseInput
                {...field}
                label='Reference number'
                placeholder='Reference number'
                required
                readOnly={!!paymentStore.data?.referenceNumber}
              />
              <ErrorMessage text={error?.message} />
            </div>
          )}
        />
        <Button className='mt-6' color='primary' type='submit' disabled={formState.isSubmitting}>
          Submit
        </Button>
      </form>
    </Modal>
  );
};
